module.exports = __webpack_public_path__ + "static/media/dashboard-scape-card-2-icon.61518d50.svg";